// extracted by mini-css-extract-plugin
module.exports = {"codeWrap":"License_codeWrap__3olii","code":"License_code__1s-dX"};